import React from 'react'
import {
    Paper,
    Typography,
    Box,
    Grid,
    LinearProgress,
    Stack,
    Divider
} from '@mui/material'
import { FormTemplate, FormStatistics as FormStatsType } from '@/core/models/form.model'

interface FormStatisticsProps {
    template: FormTemplate
    statistics: FormStatsType
}

const FormStatistics: React.FC<FormStatisticsProps> = ({ template, statistics }) => {
    return (
        <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Form Statistics</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle1" color="text.secondary">
                            Total Submissions
                        </Typography>
                        <Typography variant="h4">
                            {statistics.totalSubmissions}
                        </Typography>
                    </Box>
                </Grid>
                {statistics.fields.map((field) => {
                    const fieldConfig = template.fields.find(f => f.id === field.fieldId)
                    if (!fieldConfig) return null

                    return (
                        <Grid item xs={12} key={field.fieldId}>
                            <Paper variant="outlined" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom>
                                    {fieldConfig.label}
                                </Typography>
                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Total Responses
                                    </Typography>
                                    <Typography variant="h5">
                                        {field.totalFieldResponses}
                                    </Typography>
                                </Box>
                                <Stack spacing={2} divider={<Divider />}>
                                    {Object.entries(field.data).map(([value, count]) => {
                                        const percentage = Math.round((count / field.totalFieldResponses) * 100)
                                        return (
                                            <Box key={value}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                    <Typography variant="body2">
                                                        {value}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {count} responses ({percentage}%)
                                                    </Typography>
                                                </Box>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={percentage}
                                                    sx={{ height: 8, borderRadius: 1 }}
                                                />
                                            </Box>
                                        )
                                    })}
                                </Stack>
                            </Paper>
                        </Grid>
                    )
                })}
            </Grid>
        </Paper>
    )
}

export default FormStatistics 